export const environment = {

  production: true,

  //  apiUrl: 'http://enviodocumentos.wicpr.net/WICAPIDEV/API',

  // apiUrl: "https://backoffice360test.truenorth.pr/BackOfficeApi/api",

  // apiUrl: "https://enviodocumentos.wicpr.net/WICAPI2B/API",

  apiUrl: "https://enviodocumentos.wicpr.net/Gateway360/BackOfficeApi",

  // apiUrl :'http://18.232.226.120/WICAPITest/api',

  // apiUrlMobile:

  //   "https://enviodocumentos.wicpr.net/WICAPI2B/gateway/wicservices/api",

  apiUrlMobile:

  "https://enviodocumentos.wicpr.net/Gateway360/BackOfficeApiGateway/gateway/wicservices/api",

  secretKey: "asdwda1d8a4sd8w4das8d*w8d*asd@#",

};

 

export const environmentProductos = {

  production: true,

  apiUrl: 'https://enviodocumentos.wicpr.net/WICAPIProduct/API',

  //  apiUrl: "https://miwicprtraining.truenorth.pr/WICApiProductDev/API",

  apiUrlMobile: "https://www.wic.pr.gov/wicservices/api",

  apiUrlHelpDesk: "https://enviodocumentos.wicpr.net/HelpDeskProductDev",

  secretKey: "asdwda1d8a4sd8w4das8d*w8d*asd@#",

};

 

export const environmentComerciantes = {

  production: true,

  apiUrl: "https://enviodocumentos.wicpr.net/WICAPIComerciantesProd/api",

  //  apiUrl: 'https://enviodocumentos.wicpr.net/WICAPIComerciantesDev/api',

  //  urlFile: 'https://enviodocumentos.wicpr.net/WICAPIComerciantesDev/',

  urlFile: "https://enviodocumentos.wicpr.net/WICAPIComerciantesProd",

};

 

export const environmentEmpleados = {

  production: false,

  apiUrl: "https://wic.pr.gov/WicPortalEmpleadoAPI/api",

  //  apiUrl: 'https://wic.pr.gov/WicPortalEmpleadoAPITest/api',

  apiUrlMobile: "https://www.wic.pr.gov/wicservices/api",

  apiUrlHelpDesk: "https://enviodocumentos.wicpr.net/HelpDeskProductDev",

  secretKey: "asdwda1d8a4sd8w4das8d*w8d*asd@#",

  islogged: false,

};

 

export const environmentManuales = {

  production: false,

  //  apiUrl: "https://enviodocumentos.wicpr.net/WICAPI2B/API",
  apiUrl: "https://enviodocumentos.wicpr.net/Gateway360/BackOfficeApi",

  //apiUrl: "https://miwicprtraining.truenorth.pr/WICAPIDEV/api",

  //apiUrl : 'http://18.232.226.120/WICAPIDev/api',

  // apiUrl:"https://backoffice360test.truenorth.pr/Gateway360/WicPortal",

  // apiArchivos:"https://backoffice360test.truenorth.pr/BackOfficeApi",

  // apiArchivos: "https://enviodocumentos.wicpr.net/WICAPI2B",
  apiArchivos: "https://enviodocumentos.wicpr.net/BackOfficeApi/",


  //apiArchivos: "https://miwicprtraining.truenorth.pr/WICAPIDEV",

  apiUrlMobile: "https://www.wic.pr.gov/wicservices/api",

  secretKey: "asdwda1d8a4sd8w4das8d*w8d*asd@#",

};

 

 

export const tipoUsuario = {

  production: true,

  distribuidor: 1,

  categoryManager: 2,

  comerciantes: 3,

};

 

export const tipoEstadoSolicitud = {

  production: true,

  creado: 1,

  sometida: 2,

  rechazada: 3,

};

 